<sui-empty-state
  size="page"
  tone="danger"
  [icon]="['fas', 'circle-exclamation']"
  [title]="'page-load-error.the-page-could-not-be-loaded' | translate"
  [description]="message() ?? ''"
></sui-empty-state>
